<dx-text-box
  valueChangeEvent="keyup input change"
  [value]="value"
  [stylingMode]="stylingMode"
  [placeholder]="placeholder"
  [mode]="isPasswordMode ? 'password' : 'text'"
  (valueChange)="onValueChange($event)"
>
  <dxi-button
    name="today"
    location="after"
    [options]="{
      visible: value?.length > 0,
      icon: isPasswordMode ? 'eyeopen' : 'eyeclose',
      hoverStateEnabled: false,
      activeStateEnabled: false,
      stylingMode: 'text',
      onClick: switchMode
    }"
  ></dxi-button>
  <dx-validator
    #validator
    [validationRules]="
      validators || [{ type: 'required', message: 'Şifre Gerekli' }]
    "
  ></dx-validator>
</dx-text-box>
